var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":_vm.label,"error-messages":_vm.errorMessages,"loading":_vm.loading,"multiple":_vm.multiple,"value-comparator":_vm.compare,"items":(_vm.itemsSorted || []).map(function (item) { return ({
      text: _vm.$langobj.parse(item.name),
      value: item,
    }); }),"clearable":_vm.clearable},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}})}
var staticRenderFns = []

export { render, staticRenderFns }